import { createVanIconComponent } from "./van"

const Contact = createVanIconComponent("contact")
export default Contact
